import { Form, Input, Layout, Select, Spin } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import ClientsService from '../../services/ClientsService';
import { ClientStatus } from '../../interfaces/Client';
import CommonForm from '../../components/CommonForm/CommonForm';
import CustomBreadcrumb from '../../components/Breadcrumb/Breadcrumb';
import { ErrorContext } from '../../providers/ErrorProvider';
import ProjectsService from '../../services/ProjectsService';
import { ROUTES } from '../../constants/routes-path';
import { useNavigate } from 'react-router-dom';

const NewProject = () => {
	const [clients, setClients] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const { setError } = useContext(ErrorContext);
	const clientsService = new ClientsService();
	const projectsService = new ProjectsService();
	const { TextArea } = Input;
	const { Content } = Layout;
	const { Option } = Select;

	const routes = [
		{ path: '/projects', breadcrumbName: 'Projects' },
		{ path: '', breadcrumbName: 'Create new project' },
	];

	const backToProjects = () => {
		navigate(ROUTES.PROJECTS);
	};

	const addProject = async values => {
		setLoading(true);

		try {
			await projectsService.create({
				name: values.name,
				client: { id: values.client },
				description: values.description,
			});
			setLoading(false);
			backToProjects();
		} catch (err) {
			setError(err.toString());
			setLoading(false);
		}
	};

	const getClients = () => {
		setLoading(true);

		clientsService
			.getAllWithoutPagination()
			.then(result => {
				if (result !== undefined) {
					setClients(result.data.filter(client => client.status === ClientStatus.ENABLED));
				}
			})
			.catch(err => {
				setError(err.toString());
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getClients();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Layout style={{ height: '100vh' }}>
			<Content style={{ width: '100%' }}>
				<CustomBreadcrumb routes={routes} />
				<CommonForm
					title="Create a new project"
					primaryButton="Create Project"
					onSubmit={addProject}
					onCancel={backToProjects}
					secondClass="new-project"
				>
					<Form.Item className="field-name" name="name" label="Project Name" rules={[{ required: true }, { min: 2 }, { max: 100 }]}>
						<Input />
					</Form.Item>
					<Form.Item className="field-name" name="client" label="Client" rules={[{ required: true }]}>
						<Select
							className="client-select"
							allowClear
							style={{ width: '100%' }}
							placeholder="Select client"
						>
							{clients.map((client, index) => (
								<Option key={index} value={client.key}>
									{client.name}
								</Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item style={{ marginBottom: 0 }} name="description" label="Description" rules={[{ required: true }]}>
						<TextArea className="project common-textarea" rows={3} />
					</Form.Item>
				</CommonForm>
				{loading && <Spin style={{ display: 'flex', justifyContent: 'center' }} />}
			</Content>
		</Layout>
	);
};

export default NewProject;
